import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { LocalServiceService } from 'src/app/services/local-service.service';
import { NavigationConfirmationPromptComponent } from '../focus/navbar/navigation-confirmation-prompt/navigation-confirmation-prompt.component';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  /** Set to true by handlePopState while its own modal is open, so the guard skips showing a second modal. */
  isHandlingPopState?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private localService: LocalServiceService, public dialog: MatDialog, private overlay: Overlay) {}

  private hasUnsavedChanges(): boolean {
    return (
      this.localService.getCampaignUnsavedChanges() ||
      this.localService.getImportPatientUnsavedChanges()
    );
  }

  confirmDiscardChanges(disableClose = false): Promise<boolean> {
    if (!this.hasUnsavedChanges()) return Promise.resolve(true);

    const dialogRef = this.dialog.open(NavigationConfirmationPromptComponent, {
      disableClose,
      width: '480px',
      panelClass: 'navigation-confirmation-modal',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    });

    // If user clicked Stay -> false -> stay on page
    return firstValueFrom(dialogRef.afterClosed()).then(result => !!result);
  }

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    if (component?.isHandlingPopState) return Promise.resolve(true);

    return this.confirmDiscardChanges(false);
  }
}